import React, { Suspense, useEffect, useState } from 'react'
import Certificate from './Certificate'
import Course from './Course'
import { useDispatch, useSelector } from 'react-redux';
import LazySpinner from '../../../components/LazySpinner';
import NewRecognisedSectionModal from '../../../components/NewRecognisedSection/NewRecognisedSectionModal';
import Job from './Job';
import Cv from './Cv';
import CertificateLoader from '../Loaders/CertificateLoader';
import { checkUserAccess, setOnboardingData, setOnboardingPhase } from '../../../redux/actions/authentication';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SET_CUSTOM_SKILL_SELECTED, SET_IS_ACTIVATION, SET_ONBOARDING_IS_LOADING } from '../../../redux/actions/types';
import { createLeadScore, generateOrderId, generateRazorpayTranscript } from '../../../redux/actions/pricing';
import { RAZORPAY_KEY } from '../../../config/api_config';
import useRazorpay from 'react-razorpay';
import Constants, { leadScoringActivity } from '../../../common/constants';
import { Mixpanel } from '../../../config/Mixpanel';
import { toast } from 'react-toastify';
import { use } from 'react';
import { setPaymentRecord } from '../../../redux/actions/onBoarding';
import { getCurrentSubscriptionWithoutCache } from '../../../redux/actions/userSubscription';
import { setActivationPhase } from '../../../redux/actions/contentPayer';

const FourFlows = () => {
    const showRecognisedSection = useSelector(
        (store) => store?.userActivity?.showRecognisedSection
      );
    const dispatch = useDispatch();
    const type = useSelector((store) => store?.onBoarding?.type) || "";
    const selectedSkill = useSelector((store) => store?.onBoarding?.selectedSkill) || {};
    const goal = useSelector((store) => store?.onBoarding?.goal) || "";
    const customisedSkill = useSelector(state => state.personaliseCourse?.customSkillSelected)
    const experience = useSelector((store) => store?.onBoarding?.experience) || "";
    const betaProductUser = useSelector(store => store?.personaliseCourse?.betaUsers)
    const navigate = useNavigate()
    const user_token = useSelector(state => state?.authentication?.user_token)
    const user_name = useSelector(state => state?.profileDetails?.name)
    const email = useSelector(state => state?.profileDetails?.email)
    const phone_number = useSelector(state => state?.profileDetails?.['phone-number'])
    const id = useSelector(state => state?.profileDetails?.id)
    const xProduct = useSelector(state => state?.onBoarding?.xProduct)
    const user_id = useSelector(store => store?.profileDetails?.id)
    const [searchParams, setSearchParams] = useSearchParams()
    const successUuid = useSelector(state => state?.onBoarding?.successUuid)

    const isPremium = useSelector(state => state?.onBoarding?.isPremium)
    const Razorpay = useRazorpay()

    useEffect(() => {
      Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_FIFTH_STEP_LOADED);
  }, []);

    const handleOnboardingCompletion = (isLoading) => {

      if(type === "job"){

        dispatch(setActivationPhase((successObj)=>{
          dispatch({type: SET_IS_ACTIVATION, payload: false})
          dispatch(setOnboardingPhase((res)=>{
            navigate('/job-application-guides')
          }))
          

        }))
        return;
      }
      
      dispatch(checkUserAccess((successObj)=>{

        dispatch(setOnboardingData(selectedSkill?.id, 'morning', goal , experience, !successObj?.is_onboarded, selectedSkill?.id === 0, (res) => {
          dispatch(setOnboardingPhase((res)=>{}))
          console.log("res", customisedSkill)
              if (customisedSkill){
                  if(searchParams.get("course")){
                      navigate(`/popular-course/${searchParams?.get("course")}`);
                    }
                    else{
               navigate('/courses')}
                    
              }else{
                  navigate(`/${res?.data?.course_slug}/${res?.data?.skill_slug}/${res?.data?.mskill_slug}/${res?.data?.id}`)
              }
      }))

       }))
      
  }

    const handleOnboardingCompletionWithoutRedirection = (isLoading) => {

      if(type === "job"){

        dispatch(setActivationPhase((successObj)=>{
          dispatch({type: SET_IS_ACTIVATION, payload: false})
          dispatch(setOnboardingPhase((res)=>{}))
        }))
        return;
      }
      if(type === "cv"){
        dispatch(setActivationPhase((successObj)=>{
          dispatch({type: SET_IS_ACTIVATION, payload: false})
          dispatch(setOnboardingPhase((res)=>{}))
        }))
        return;
      }
      if(type === "course" && isPremium){
        dispatch(setActivationPhase((successObj)=>{
          dispatch({type: SET_IS_ACTIVATION, payload: false})
        }))
      }

      if(type === "certificate" && isPremium){
        return;
      }

      
      dispatch(checkUserAccess((successObj)=>{

        dispatch(setOnboardingData(selectedSkill?.id, 'morning', goal , experience, !successObj?.is_onboarded, selectedSkill?.id === 0, (res) => {}))
          dispatch(setOnboardingPhase((res)=>{}))
       }))
    }

  const handleSetIsLoading = (isLoading) => {
    dispatch({type: SET_ONBOARDING_IS_LOADING, payload: isLoading});
}

const razorpayMainHandler = ((e, callback) => {
  //console.log(e);
  dispatch(generateOrderId(user_token, e, successObj => {

    const options = {
      key: RAZORPAY_KEY,
      amount: `${successObj?.product_details?.cost * 100}`,
      currency: "INR",
      name: successObj?.product_details?.product_name,
      description: successObj?.product_details?.product_description_short,
      image: successObj?.product_details?.pp_product_image?.url,
      order_id: successObj?.razorpay_order_id,
      modal: {
        "ondismiss": function () {
          callback()
        }
      },
      handler: (res) => {
        getOrderMainStatusSuccess(res)
        callback();
      },
      prefill: {
        name: user_name,
        email: email,
        contact: phone_number,
      },
      // notes: {
      //     address: "Razorpay Corporate Office"
      // },
      theme: {
        color: "#26CBA7"
      }
    }


    const razorpayInitializor = new Razorpay(options)

    razorpayInitializor.on("payment.failed", function (response) {
      getOrderMainStatusFailure(response)
      callback()
    });

    razorpayInitializor.open()

  }))

})

function getOrderMainStatusSuccess(response) {
  dispatch(generateRazorpayTranscript(
    user_token,
    {
      payment_id: response?.razorpay_payment_id,
      order_id: response?.razorpay_order_id,
      isError: false,
      razorpay_signature: response?.razorpay_signature,
      errorObj: {}
    },
    (successObj) => {
      
      dispatch(createLeadScore(id, leadScoringActivity.PURCHASED_SUBSCRIPTION.type,response?.razorpay_order_id))
      Mixpanel.track(Constants.Mixpanel.PURCHASED_SUBSCRIPTION , {
        distinct_id: email
      })
      if(type === "job"){
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_JOB_PAGE_SUBSCRIPTION_PURCHASED);
      }
      if(type === "cv"){
        Mixpanel.track(Constants.Mixpanel.ONBOARDING_PAGE_25_CV_PAGE_SUBSCRIPTION_PURCHASED);
      }
      handleSetIsLoading(true);
  

      if(type === "job"){
        
        setTimeout(() => {
          handleOnboardingCompletion();
        }, 4000)
      }else if(type === "cv"){
        handleOnboardingCompletionWithoutRedirection()
        dispatch(getCurrentSubscriptionWithoutCache(user_id, (res) => {
          dispatch(setPaymentRecord(user_name, email, "paid", xProduct?.cost, xProduct?.product_name, response?.razorpay_payment_id, response?.razorpay_order_id, res?.current_subscription_expires_at/1000, (res) => {
            console.log("res", res)
          }, (error) => {
            console.log("error", error)
          }))

        }))
      }
    }
  ))
  // console.log(response)
}


function getOrderMainStatusFailure(response) {
  dispatch(generateRazorpayTranscript(
    user_token,
    {
      payment_id: response?.error?.metadata?.payment_id,
      order_id: response?.error?.metadata?.order_id,
      isError: true,
      razorpay_signature: "",
      errorObj: { ...response?.error }
    },
    successObj => {
      toast.error("something went wrong. Please try again later")
    }
  ))
  // console.log(response)
}

  return (

<div className='w-full pb-6'> 
    {type === "certificate" ? <Certificate handleOnboardingCompletion={handleOnboardingCompletion} handleSetIsLoading={handleSetIsLoading} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/> : 
    type === "course" ? <Course handleOnboardingCompletion={handleOnboardingCompletion} handleSetIsLoading={handleSetIsLoading} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/> :
    type === "job" ? <Job razorpayMainHandler={razorpayMainHandler} handleOnboardingCompletion={handleOnboardingCompletion} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/> : 
    type === "cv" ? <Cv razorpayMainHandler={razorpayMainHandler} handleOnboardingCompletion={handleOnboardingCompletion} handleOnboardingCompletionWithoutRedirection={handleOnboardingCompletionWithoutRedirection}/> : <CertificateLoader />}
    {showRecognisedSection && (
        <Suspense fallback={<LazySpinner />}>
          <NewRecognisedSectionModal showRecognisedSection={showRecognisedSection} />
        </Suspense>
      )}
    </div>
  )
}

export default FourFlows